import {GET_WECHAT_REGISTER_PROFILE} from '../mutiation'

// initial state
// shape: [{ id, quantity }]
const state = {
  profile: {},
  isWechatRegister: false
}

// actions
const actions = {

}

// mutations
const mutations = {
  [GET_WECHAT_REGISTER_PROFILE] (state, profile) {
    state.profile = Object.assign({}, profile, {
      headUrl: profile.headUrl
    })
    state.isWechatRegister = true
  }
}
const getters = {

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/pages/index/store/modules/register.js